<template>
  <div class="pa-5" id="topics">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
         <v-card-title class="descriptiontitle">
         <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1">
        mdi-arrange-bring-forward
        </v-icon>
              {{ item.descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
              </v-col>
              </div>
              <div style="text-align:center; color:#C62828;" class="px-4">試用など各種ご相談お問い合わせは、こちらからお願いいたします。</div>
  </div>
</template>

<style>
.summary {
  white-space:pre-wrap;
  word-wrap:break-word;
  margin-top:-1rem;
  }
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '機能',
      // タイトル横のアイコン
      icon: 'mdi-cog-outline',
      contents: [
        {
          // 説明タイトル
          descriptiontitle: '患者',
          // 説明文
          description: `
・患者
・新規登録
・スマホ、携帯、PCから時間予約
・予約のキャンセル
・家族予約
・メール通知`
        },
        {
          // 説明タイトル2
          descriptiontitle: 'スタッフ',
          // 説明文2
          description: `
・院内予約
・予約枠調整
・予約状況印刷
・リコール管理
・処置管理
・休日管理
・統計機能(Excel出力)
・スタッフ管理
・医院からのお知らせ`
        }
      ]
    }
  }
}
</script>
